// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1XYCN","productName":"Table_productName__2n_eN"};